<div class="h-screen w-screen flex flex-col justify-center items-center overflow-hidden">
  <app-logo class="animate-wiggle"></app-logo>
  <h1 class="text-2xl termina-regular">404 - Not Found</h1>
  <a class="text-md text-hyperlink hover:underline" routerLink="">Back to charted waters</a>
</div>
